// ============================================================
// หน้า Role — บทบาทผู้ใช้
// ------------------------------------------------------------
// รายการบทบาท (ชุดสิทธิ์) ที่เอาไปผูกกับผู้ใช้แต่ละคน
// เพิ่ม/แก้ไข อยู่คนละหน้า (/create-role, /update-role?id=...)
// ============================================================

import React, { Component } from "react";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, success, GET, DELETE, loading, permission, Paginate, ActionIcon, ConfirmModal, ICON } from "../../shared/index.js";

const perm = permission("role");

export default class Role extends Component {
  state = { modal_delete: false, page: 1, filter_data_search: "", data: null, role_id: "" };

  componentDidMount() {
    if (perm.view) this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/role-manage/filter-search/page/${this.state.page}`, { data_search: this.state.filter_data_search });
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  Delete = async () => {
    loading(true);
    const result = await DELETE(tokens, `v1/TH/role-manage/delete/${this.state.role_id}`, null);
    if (result?.status) {
      this.setState({ modal_delete: false, page: 1, filter_data_search: "" });
      success();
      this.GetAll();
    }
    loading(false);
  };

  render() {
    const s = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="บทบาทผู้ใช้" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* หัวข้อ + ปุ่มเพิ่ม */}
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>บทบาทผู้ใช้</b>
                </h4>
                {perm.create && (
                  <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => (window.location.href = "/create-role")}>
                    เพิ่มบทบาท
                  </button>
                )}
              </div>

              {/* ตัวกรอง */}
              {perm.view && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <input
                      type="search"
                      className="form-control wpx-200 bg-contain border-0 mx-1 mb-3"
                      placeholder="พิมพ์คำค้นหา..."
                      value={s.filter_data_search}
                      onChange={(e) => this.setState({ filter_data_search: e.target.value })}
                    />
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                      ค้นหา
                    </button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_data_search: "", page: 1 }, this.GetAll)}>
                      รีเซ็ท
                    </button>
                  </div>
                </div>
              )}

              {/* ตารางบทบาท */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-left">บทบาท</th>
                      <th className="text-left">รายละเอียด</th>
                      {(perm.update || perm.delete) && <th className="text-center">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? (
                      <tr>
                        <td colSpan={3} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      s.data.data.map((item, i) => (
                        <tr key={i}>
                          <td>{item.role_name || "-"}</td>
                          <td>{item.role_description || "-"}</td>
                          {(perm.update || perm.delete) && (
                            <td className="text-center d-flex">
                              {perm.update && <ActionIcon color="primary" icon={ICON.edit} title="แก้ไข" className="mr-2" onClick={() => (window.location.href = "/update-role?id=" + item.role_id)} />}
                              {perm.delete && <ActionIcon color="danger" icon={ICON.delete} title="ลบ" onClick={() => this.setState({ role_id: item.role_id, modal_delete: true })} />}
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={s.data} page={s.page} onChange={(value) => this.setState({ page: value }, this.GetAll)} />
            </div>
          </div>
        </div>

        <ConfirmModal
          show={s.modal_delete}
          title="ยืนยันการลบผู้ใช้งาน"
          message="ท่านแน่ใจว่าต้องการลบข้อมูล หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้"
          onCancel={() => this.setState({ modal_delete: false })}
          onConfirm={this.Delete}
        />
      </div>
    );
  }
}
